<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-table-pagination">
    <div class="total-record">{{ tableModel.totalRecs }} Results</div>
    <el-pagination 
      layout="prev, pager, next" 
      :disabled="isTableLoading"
      :current-page="dataModel.page.number"
      :page-size="dataModel.page.size" 
      :total="tableModel.totalRecs"
      :pager-count="7"
      @current-change="handlePageChange">
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'wy-table-pagination',
  props: ["callback", "isTableLoading"],

  computed: {
    ...mapGetters(['dataModel', 'tableModel'])
  },

  methods: {
    handlePageChange(currentPage) {
      this.callback(currentPage);
    }
  }
}
</script>

<style lang="scss">
.wy-table-pagination {
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: center;
  display: inline-flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  .el-pagination {
    padding-left: 0px;

    .el-pager li.btn-quicknext, .el-pager li.btn-quickprev {
      // display: none;
    }
    .el-icon.more.btn-quickprev.el-icon-more, .el-icon.more.btn-quicknext.el-icon-more {
      pointer-events: none;
    }
    .el-pager li {
      font-size: 14px;
      min-width: 30px;
      font-weight: 500;
      border-radius: 5px;
    }
    .el-pager li.active {
      background-color: #E8F3FF;
    }
    .btn-prev,.btn-next {
      .el-icon {
        font-size: 16px;
      }
    } 
  }
  .first-page, .last-page {
    display: none;
    width: 90px;
    // display: inline-flex;
    justify-content: space-evenly;
  }
  .total-record {
    color: #64727C;
    font-size: 14px;
    font-style: normal;
    font-weight: 400; 
    width: 200px;
    justify-content: space-evenly;
  }
}
</style>
